<div class="container-fluid bg-primary-light py-2">
  <div class="row">
    <div class="col-6 d-flex align-items-center">

      <button
        class="btn pt-2 pb-0 d-block d-md-none"
        (click)="slideMenuService.showed = !slideMenuService.showed">
        <i class="material-icons">menu</i>
      </button>

      @if(title) {
        <div class="ps-2 ps-md-0 text-truncate">
          <b>{{ title }}</b>
        </div>
      } @else if(neighborhoodService.loadingCurrent) {
        <div class="ps-2 ps-md-0 placeholder-glow">
          <span class="visually-hidden">Cargando colonia</span>
          <span
            class="placeholder px-5 py-1 rounded bg-dark bg-opacity-25"
            aria-hidden="true"></span>
        </div>
      }

    </div>

    <!-- Campana y cuenta comparten la columna que ya existía: no se agrega
         ninguna fila nueva. -->
    <div class="col-6 d-flex align-items-center justify-content-end">

      <app-notifications-bell
        [neighborhoodId]="neighborhoodId">
      </app-notifications-bell>

      <div ngbDropdown class="d-inline-block">
        <button type="button" class="btn text-truncate" id="dropdownBasic1" ngbDropdownToggle>
          @if(authService.currentUser) {
            {{ authService.currentUser.fullName }}
          } @else {
            <span class="placeholder-glow">
              <span class="visually-hidden">Cargando usuario</span>
              <span
                class="placeholder px-5 rounded bg-dark bg-opacity-25"
                aria-hidden="true"></span>
            </span>
          }
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          @if(neighborhoodService.neighborhoods.length > 1 || authService.currentUser?.profile === 'sudo') {
            <a
              ngbDropdownItem
              class="d-flex align-items-center"
              [routerLink]="['/dashboard/neighborhoods']">
              <i class="material-icons me-1">house</i>
              Colonias
            </a>
            <div class="dropdown-divider"></div>
          }

          <!-- Las preferencias son por fraccionamiento: fuera de uno no hay
               nada que configurar aquí. -->
          @if(neighborhoodId) {
            <button
              ngbDropdownItem
              class="d-flex align-items-center"
              (click)="openPreferences()">
              <i class="material-icons me-1">tune</i>
              Preferencias
            </button>
            <div class="dropdown-divider"></div>
          }

          <button
            ngbDropdownItem
            class="d-flex align-items-center text-danger"
            (click)="authService.signOut()">
            <i class="material-icons me-1">logout</i>
            Cerrar sesión
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
